import _defineProperty from "/home/runner/work/freeCodeCamp/freeCodeCamp/node_modules/.pnpm/@babel+runtime@7.27.3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { constructFrom } from "../../../constructFrom.js";
import { Parser } from "../Parser.js";
import { parseAnyDigitsSigned } from "../utils.js";
export class TimestampSecondsParser extends Parser {
  constructor() {
    super(...arguments);
    _defineProperty(this, "priority", 40);
    _defineProperty(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value * 1000), {
      timestampIsSet: true
    }];
  }
}